import axios from "axios"
import { putEmergency } from "./emergencySlice";


export function emergencyPutAxios(emergencyData) {
        return async function emergencyPutThunk(dispatch, getState) {
            const response = await axios.put(`/api/emergency`, emergencyData)
            dispatch(putEmergency(response.data))
        };
    }